import React from 'react';
import { Accordion } from 'react-bootstrap';
import { ResourceReference, SpecItemData } from '../../../../types';
import { ReactComponent as Circle } from "bootstrap-icons/icons/circle.svg";
import { ReactComponent as CheckCircle } from "bootstrap-icons/icons/check-circle-fill.svg";
import { ReactComponent as Tag } from "bootstrap-icons/icons/tag-fill.svg";
import { QueryProps } from '../../resourceIndexUI/ResourcesIndexUI';
import { AllParams } from '../ResourcesFilter';
import { useLocale } from '../../../../i18n/hooks';
import { useTranslation } from 'react-i18next';

type Props = {
  isLoading?: boolean;
  query: QueryProps;
  allParams: AllParams;
  handleQueryItemClick: (
    thisValue: string,
    thisQueryType: keyof QueryProps,
  ) => void;
  resources: ResourceReference[] | undefined;
  specItems: SpecItemData | undefined;
  noSpecItems: boolean | undefined;
};

const SpecificationFilter: React.FC<Props> = ({ isLoading, query, handleQueryItemClick, allParams, specItems, noSpecItems, resources}) => {
  const locale = useLocale();
  const { t: _ } = useTranslation();

  const specItemCheck = (spec: string, title: string) => (
    <div
      key={spec}
      onClick={() => handleQueryItemClick(spec, "specItem")}
      className={`w-100 btn text-start py-0`}
    >
      {spec === query.specItem ? <CheckCircle /> : <Circle />}
      &emsp;
      {_(title)}
    </div>
  );

  const generateAccordion = (specItem: any[], level?: string) => {
    if (specItem && specItem.length > 0) {
      return (
        <>
          <Accordion>
            {specItem.map((specItem, index) => {
              const _level = level ? `${level}.${index}` : `${index}`;

              if (
                resources &&
                resources.filter((resource: ResourceReference) =>
                  resource.SpecItem.startsWith(_level),
                )?.length > 0
              ) {
                return (
                  <React.Fragment key={_level}>
                    {specItem.children ? (
                      <Accordion.Item
                        className="bg-light mb-2 rounded"
                        eventKey={`${_level}`}
                      >
                        <Accordion.Header>
                          {specItemCheck(_level, specItem.title[locale])}
                        </Accordion.Header>
                        <Accordion.Body>
                          {generateAccordion(specItem.children, `${_level}`)}
                        </Accordion.Body>
                      </Accordion.Item>
                    ) : (
                      specItemCheck(_level, specItem.title[locale])
                    )}
                  </React.Fragment>
                );
              } else {
                return <React.Fragment key={_level}></React.Fragment>;
              }
            })}
          </Accordion>
        </>
      );
    }
  };

  return (
    <div className="card shadow mb-3 spec-filter" key="spec-filter">
        <div className="card-body">
          <h5>{_("Spec Items")}</h5>
          {noSpecItems ? (
            <p>{_("No spec item exists yet")}</p>
          ) : specItems ? (
            <>
              {isLoading &&
                Array(4)
                  .fill(null)
                  .map((_, i) => (
                    <button
                      key={`tag${i}`}
                      className={`btn rounded-pill p-0 me-2 text-decoration-none btn-link`}
                    >
                      <Tag />
                      &thinsp;
                      <span className="placeholder">
                        &emsp;&emsp;&emsp;{i % 2 === 0 && "&emsp;"}
                      </span>
                    </button>
                  ))}

              {generateAccordion(specItems.spec)}
            </>
          ) : (
            <p>{_("Please select a qualification")}</p>
          )}
        </div>
      </div>
  )
}

export default SpecificationFilter;